// import Layout from '../Layout'
const Layout = () =>
  import(/* webpackChunkName: "group-login" */ "../Layout.vue");

export default [
  {
    path: "/forgotpassword/:guid?",
    name: "forgotpassword",
    component: Layout,
  },
];
